const items = {
  title: 'Calendario',
  description: 'En esta sección puede visualizar por mes todos los servicios y no conformidades generadas',

  title1: 'Acciones generadas',
  description1: 'Acciones generadas o no conformidades generadas en formato de lista para consulta',

  title2: 'Lugares',
  description2: 'Navegue por todos los lugares y sectores de su empresa, seleccionando alguna de estas lugares puede ver los equipos',

  title3: 'Mapa',
  description3: 'Ver equipos y lugares a través de Google Maps',

  title4: 'Dashboard',
  description4: 'Dashboard con varios análisis y filtros.',

  title5: 'Equipos',
  description5: 'Lista de todos los equipos registrados',

  title6: 'Servicios realizados',
  description6: 'Lista de todos los servicios realizados',

  title7: 'Terceras empresas',
  description7: 'Terceras empresas registradas',
}

export default items;
